import React from "react";
import { Link } from "react-router-dom";

const Welcome = () => {
  return (
    <div
      className="min-h-screen relative"
      style={{
        backgroundImage:
          'url("/uploads/1744491413140-Navajo-Res-Landscape-Painterly.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center py-6 px-6 sm:px-6 lg:px-8">
        <div className="max-w-3xl w-full">
          <div className="mb-4 mt-10 relative flex flex-col items-center">
            <img
              src="/uploads/Native-symbol-icon.png"
              alt="generalized native symbol art obsidian black"
              width="120"
              height="auto"
            />
          </div>
          <h1 className="text-6xl font-semibold text-obsidian-black mb-8 text-center">
            The Whispering Stones
          </h1>
          <div
            className="mb-4"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              padding: "25px",
              borderRadius: "20px",
            }}
          >
            <p className="text-[1.2rem] text-obsidian-black mb-6 text-left">
              You are <strong>Daniel Yazzie</strong>, a young forensic
              anthropology student visiting your uncle,{" "}
              <strong>Sergeant Ben Nez</strong>, of the Navajo Tribal Police.
              You expected a quiet break in the Four Corners region, but fate
              has other plans.
            </p>
            <p className="text-[1.2rem] text-obsidian-black mb-6 text-left">
              A local elder, <strong>Mary Tsosie</strong>, has gone missing from
              her remote home near the Canyon de Chelly. The only clue left
              behind is a strange bundle of{" "}
              <strong>handwoven corn husk dolls</strong> arranged in a spiral on
              her kitchen table. Your uncle believes this may be a warning, but
              he refuses to say more.
            </p>
            <p className="text-[1.2rem] text-obsidian-black text-left">
              Then, late at night, you receive an anonymous note slid under your
              door:
              <br />
              <em>
                "Follow the whispering stones before they are lost forever."
              </em>
            </p>
          </div>
          <div className="space-y-4 text-center">
            <Link
              to="/chapter/1"
              className="block w-full sm:w-auto mx-auto px-8 py-3 border border-transparent text-base font-medium rounded-md text-sacred-white bg-turquoise-green hover:bg-sky-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-turquoise-green max-w-[350px]"
            >
              Your Investigation Begins Now
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
